// extracted by mini-css-extract-plugin
export default {"nav-content":"CeFMgunN7ZZSp_Yp2CS6","left-img":"CsXErih5xw6BAvvhnOpu","nav-bg":"tAQ8pFMOb5JcgODs0tMQ","swipper-img":"rb4mOO8RzPLN8poDon7v","nav-list":"vV_Pei_MFAMYjvN1c0eL"};